declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';






@Component({
  selector: 'employee',
  templateUrl: './employee.component.html',
  styleUrls: [
    './employee.component.scss']
  , animations: [routerTransition()]
})

export class EmployeeComponent implements OnInit {

  
  public ShowList: boolean = true;
  public AddEmployee: boolean = false;
  public EditEmployee: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  public ApiResData: ApiResponseModel;



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }

  ngOnInit() {



  }
  url;
  msg = "";
  selectFile(event) {
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }
  }
  url2;
  msg2 = "";
  selectFile2(event) {
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg2 = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg2 = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (_event) => {
      this.msg2 = "";
      this.url2 = reader.result;
    }
  }

  AddNewEmployee() {
    this.ShowList = false;
    this.AddEmployee = true;
    this.EditEmployee = false;
  }
  EditEmpl() {
    this.ShowList = false;
    this.AddEmployee = false;
    this.EditEmployee = true;
  }
  Cancel() {
    this.ShowList = true;
    this.AddEmployee = false;
    this.EditEmployee = false;
  }
  profile() {
    let m = document.querySelector("#profile");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  demographics() {
    let m = document.querySelector("#demographics");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  education() {
    let m = document.querySelector("#education");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  user() {
    let m = document.querySelector("#user");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  branch() {
    let m = document.querySelector("#branch");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  contact() {
    let m = document.querySelector("#contact");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  contactdetails() {
    let m = document.querySelector("#contactdetails");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  image() {
    let m = document.querySelector("#image");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  signature() {
    let m = document.querySelector("#signature");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


}
